const getUniqueCompsetName = (ulid) => `Compset-${ulid.substr(0, 10)}`;

export default getUniqueCompsetName;
